import type { Control, FieldValues } from 'react-hook-form';

import type { FormCustomRenderer } from '@packages/form-engine/types/renderer';

import { RhfCustomRecurrenceEnds } from './RhfCustomRecurrenceEnds';

export const customRecurrenceEndsRenderer: FormCustomRenderer = function CustomRecurrenceEndsRenderer({
  control,
}) {
  return <RhfCustomRecurrenceEnds control={control as Control<FieldValues>} />;
};
